export enum IncentivesEvent {
	// modal events
	OpenClaimIncentive = 'open-claim-incentive',

	// analytics events
	IncentivesPageViewed = 'Incentives Page Viewed',
	IncentiveDetailsPageViewed = 'Incentive Details Page Viewed',

	ClaimIncentiveModalViewed = 'Claim Incentive Modal Viewed',
	ClaimIncentiveModalClosed = 'Claim Incentive Modal Closed',
	ClaimIncentiveRequestSubmitted = 'Claim Incentive Request Submitted',
	ClaimIncentiveSuccess = 'Claim Incentive Success',
	ClaimIncentiveFailure = 'Claim Incentive Failure',
}
